var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-image',{staticStyle:{"max-width":"120px","max-height":"120px"},attrs:{"src":_vm.item.content,"preview-src-list":[_vm.item.content]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }